var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDoorNone = function SvgDoorNone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.62 22.8a1.29 1.29 0 0 1-1.82 1.82l-6.8-6.8-6.8 6.8a1.29 1.29 0 0 1-1.82-1.82l6.8-6.8-6.8-6.8A1.29 1.29 0 0 1 9.2 7.38l6.8 6.8 6.8-6.8a1.29 1.29 0 0 1 1.82 1.82l-6.8 6.8z"
  })));
};
export default SvgDoorNone;